<!--
  LanguageSelector.svelte — Flag-based language picker using AbstractDropdown.

  Binds to the i18n locale store. Renders flag images for both the
  trigger button and dropdown items.
-->
<script lang="ts">
	import { Img } from 'flowbite-svelte';
	import AbstractDropdown from './AbstractDropdown.svelte';
	import { locale, locales, localeFlags, localeNames } from '../i18n';

	let { class: className = '', buttonClass = '' }: { class?: string; buttonClass?: string } = $props();

	/** Map locales to AbstractDropdown items. */
	const items = locales.map((l) => ({ name: localeNames[l] ?? l, value: l }));

	/** Resolve a locale code to its flag SVG path. */
	function flagSrc(loc: string): string {
		return `/flags/${localeFlags[loc] || loc}.svg`;
	}
</script>

<AbstractDropdown {items} bind:value={$locale} class={className} {buttonClass}>
	{#snippet children(item)}
		<Img class="rounded-sm" src={flagSrc(String(item.value))} />
	{/snippet}
</AbstractDropdown>
